<!--
 * @Author: yaoyuting
 * @Date: 2021-04-11 18:24:56
 * @LastEditors: yaoyuting
 * @LastEditTime: 2021-05-19 19:49:54
 * @Descripttion:
-->
<template>
  <div class="Blog">
    <div class="title">
      <div class="BigTitle">{{blogData.blogTitle}}</div>
      <div class="time">{{blogData.createTime}}</div>
      <div class="line"></div>
<!--      <img class="example" src="../../../assets/icon/success.png"/>-->
    </div>
    <div class="box-card">
      <div class="detail"  v-html="blogData.text"></div>
      <div class="bu-bottom">
        <div class="join">{{ $t("Blog.join") }}</div>
        <div class="text">{{ $t("Blog.detail") }}</div>
        <div class="input">
          <el-input  v-model="Email" :placeholder="$t('Blog.email')" ></el-input>
          <div class="button"  @click="subBlog()">{{ $t("Blog.sign") }}</div>
        </div>
      </div>
    </div>

<!--    <div class="title">-->
<!--      <div class="BigTitle">The implementation of the high-performance infrastructure</div>-->
<!--      <div class="time">AUG 20 · 3 min read</div>-->
<!--      <div class="line"></div>-->
<!--    </div>-->
<!--    <div class="box-card">-->
<!--      <div class="detail">{{ $t("Fund.learnMore") }} </div>-->
<!--      <div class="bu-bottom">-->
<!--        <div class="join">{{ $t("Blog.join") }}</div>-->
<!--        <div class="text">{{ $t("Blog.detail") }}</div>-->
<!--        <div class="input">-->
<!--          <el-input  v-model="Email" :placeholder="$t('Blog.email')" ></el-input>-->
<!--          <div class="button">{{ $t("Blog.sign") }}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="line-blue"></div>
  </div>
</template>

<script>
import {
  GetBlogDetail,
  SubBlog,
} from '@/assets/server/api.js';
import { formatDateStr } from "@/utils/utils";
export default {
  data() {
    return {
      Email: '',
      blogData: [],
      dialogVisible: false,
      monthEnglish:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"],
    };
  },
  created() {
    this.getBlogList(this.$route.query.id);
  },
  destroyed() {
  },
  methods: {
    async getBlogList(id) {
      const data = await GetBlogDetail(id);
      if (data.code === 0) {
        let date = new Date(formatDateStr(data.data.createTime));
        let month = this.monthEnglish[date.getMonth()];
        let day = date.getDate();
        data.data.createTime = month +' '+ day;
        data.data.images = data.data.images;
        data.data.text = data.data.text.replace(/\n/g, '<br>');
        this.blogData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.Email = "";
    },
    async subBlog() {
      let id = this.blogData.blogId;
      let reg = /\w+@[a-z0-9]+\.[a-z]{2,4}/;
      if (!reg.test(this.Email)) {
        return this.$notify({
          type: "warning",
          message: "Enter the correct email",
        });
      }
      console.log(this.Email)
      let info = id + "/" + this.Email;
      console.log(info)
      const data = await SubBlog(info);
      if (data.code === 0) {
        this.$confirm('<img style="width: 11.3vw;height: 11.3vw;" src="https://www.donetwork.io/img/success.png" /> </br>' +
                '<p style="padding-top: 4vw;">Subscription Successful</p>', {
          confirmButtonText: 'OK',
          confirmButtonClass: 'OkButton',
          buttonColor: '#F4F5F7',
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          showClose: false,
          center: true,
          customClass:'successBox'
        });
        this.handleClose();
      } else {
        this.$message.error(data.msg);
      }
    },
    getTimeStamp(date){
      //current time
      let days ="";
      let timestamp = parseInt(Date.parse(new Date()) / 1000);
      let strdate = parseInt(Date.parse(date)/ 1000);
      let s = timestamp - strdate; //9.20
      let fenzhong = parseInt((s / 86400) * 24 * 60);
      // console.log(fenzhong);
      if (fenzhong < 60) {
        if (fenzhong == 0) {
          days = "just now read";
        } else {
          days = parseInt(fenzhong) + "min read";
        }
      }
      if (fenzhong >= 60 && fenzhong <= 1440) {
        days = parseInt(fenzhong / 60) + "hour read";
      }
      if (fenzhong > 1440) {
        days = parseInt(fenzhong / 1440) + "day read";
      }
      return days;
    },
  },
};
</script>

<style>
  .input input.el-input{
    width: 650px;
    height: 100px;
    border-radius: 50px 50px 50px 50px;
    opacity: 1;
    border: 2px solid #C1C1C1;
  }
  .input input.el-input__inner{
    padding-left: 40px;
    width: 650px;
    height: 100px;
    border-radius: 50px 50px 50px 50px;
    opacity: 1;
    border: 2px solid #C1C1C1;
    font-size: 26px;
    /*font-family: Microsoft YaHei-Regular, Microsoft YaHei;*/
    font-weight: 400;
    color: #C1C1C1;
    line-height: 30px;
  }
  .el-input__label {
    font-size: 20px;
    margin-left: -12px;
  }
  /*.detail {*/
  /*  margin-top: 60px;*/
  /*  font-size: 133%;*/
  /*  word-wrap: break-word;*/
  /*}*/
  /*img{*/
  /*  max-width: 650px;*/
  /*}*/
  .el-message-box{
    width: 690px;
    height: 400px;
    background: #F4F5F7;
    border-radius: 0px 0px 0px 0px;
    border-top: 10px solid #4573E7;;
    opacity: 1;
  }
  .el-message-box__message{
    font-size: 30px;
    font-family: PingFang SC-中粗体, PingFang SC;
    font-weight: normal;
    color: #2B2D41;
    line-height: 42px;
  }
  .el-button:nth-child(1) {
    width: 200px;
    height: 67px;
    margin: 0 auto;
    border-color: #4573E7;
    background: #4573E7;
    opacity: 1;
    border-radius: 4px;
    color: #ffffff;
    font-size: 26px;
    font-family: PingFang SC-中粗体, PingFang SC;
    font-weight: normal;
    line-height: 36px;
  }

  .successBox .el-message-box__header{
    padding-top:20px;
  }
</style>
<style lang="less" scoped>

  .Blog {
    text-align: center;
    width: 100%;
    color: #000000;
    .title {
      text-align: center;
      min-height: 471px;
      background: url("../../../assets/m/intro/bgi.png") no-repeat center/100%
      100%;
      .BigTitle{
        padding-top: 230px;
        margin: 0 auto;
        width: 650px;
        font-family: Poppins-SemiBold, Poppins;
        font-size: 64px;
        font-weight: 600;
        color: #000000;
        line-height: 83px;
        letter-spacing: 1px;
        text-align: left;
        word-wrap: break-word;
        /*display: -webkit-box;*/
        /*-webkit-box-orient: vertical;*/
        /*-webkit-line-clamp: 3;*/
        /*overflow: hidden;*/
      }
      .time{
          margin: 60px 0 60px 50px;
          opacity: 1;
          font-size: 20px;
          font-family: Ubuntu-Regular, Ubuntu;
          font-weight: 400;
          color: #4573E7;
          line-height: 42px;
          letter-spacing: 1px;
          width: 120px;
          height: 42px;
          background: rgba(50, 120, 255, 0.05);
          border-radius: 0px 0px 0px 0px;
          text-align: center;
      }
      .line{
        margin: 0 auto;
        width: 670px;
        height: 0px;
        opacity: 1;
        border: 2px solid #EBEBEB;
      }
    }
    .box-card {
      /*margin-top: -202px ;*/
      text-align: center;
      .detail{
        padding-top: 20px;
        margin: 0 auto;
        width: 650px;
        /*font-size: 30px;*/
        /*font-family: PingFang SC-Medium, PingFang SC;*/
        /*font-weight: 500;*/
        /*color: #61666B;*/
        /*line-height: 63px;*/
        /*letter-spacing: 1px;*/
        text-align: left;
        word-wrap: break-word;

        /deep/ img{
          max-width:100% !important;
        }
        /deep/ iframe{
          max-width:100% !important;
        }
        table {
          width: 100% !important;
        }
        .MsoNormalTable {
          width: 100% !important;
          td {
            width: 50px !important;
          }
        }
      }
      .bu-bottom{
        background: rgba(69, 115, 231, 0.03);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        padding-bottom: 153px;
        .join{
          padding-top: 78px;
          padding-left: 50px;
          padding-bottom: 10px;
          font-size: 40px;
          text-align: left;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000000;
          line-height: 47px;
        }
        .text{
          width: 650px;
          font-size: 26px;
          margin: 0 auto;
          text-align: left;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #4573E7;
          line-height: 46px;
          letter-spacing: 1px;
          margin-bottom: 60px;
          word-wrap: break-word;
        }
        .button{
          width: 280px;
          height: 100px;
          border-radius: 50px 50px 50px 50px;
          opacity: 1;
          border: 2px solid #4573E7;
          background: #FFFFFF;
          margin-top: 60px;
          margin-left: 50px;
          font-size: 30px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4573E7;
          line-height: 100px;
          letter-spacing: 1px;
        }
      }
    }
    .line-blue{
      height: 16px;
      width: 100%;
      background: #4573E7;
    }
  }
</style>
